<template>
  <van-action-sheet v-model="showSheet" class="van-share-sheet" :title="$t('Share[6]')" :cancel-text="$t('Share[12]')" :closeable="false">
    <div v-if="shareOptions.length" class="van-share-sheet__options" :style="shareOptions.length<4?'justify-content: center;':''">
      <div v-for="item,index in shareOptions" :key="index" class="van-share-sheet__option" :class="{'van-action-sheet__item--disabled':item.is_share==1}" @click="item.is_share==1?false:onSelectShare(item.id)">
        <img :src="item.icon" class="van-share-sheet__icon">
        <span class="van-share-sheet__name">{{item.name}}</span>
        <p style="font-size:12px;color:var(--color-active)">{{$t('Share[14]')}}{{InitData.currency}}{{item.reward}}</p>
        <p style="font-size:12px;color:var(--color-assist)" v-if="item.status_dec">{{item.status_dec}}</p>
      </div>
    </div>
    <van-loading v-else style="text-align:center;padding: 20px 0" />
  </van-action-sheet>
</template>

<script>
export default {
  name: 'Share',
  components: {

  },
  props: {
    shareType: {
      type: String,
      default: ''
    },
    shareDan: {
      type: String,
      default: ''
    },
    shareOptions: {
      type: Array,
      default: ()=> []
    }
  },
  data() {
    return {
      showSheet: false,
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    
  },
  mounted() {
    
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    onSelectShare(id) {
      this.showSheet = false
      this.$router.push(`/shareDetail/${id}/${this.shareType}/${this.shareDan||''}`)
    },
  }
}
</script>
<style scoped>
.van-share-sheet>>>.van-share-sheet__title{
  font-size: 16px;
  font-weight: 600;
}
.van-share-sheet>>>.van-share-sheet__options{
  padding-left: 0;
}
.van-share-sheet>>>.van-share-sheet__description{
  overflow: hidden;
}
.van-share-sheet>>>.van-share-sheet__description .code{
  font-size: 14px;
  margin: 10px 0;
  color: var(--color-main);
}
.van-share-sheet>>>.van-share-sheet__description input{
  border: 1px solid var(--border-color-main);
  background-color: var(--background-theme);
  border-radius: 5px;
  font-size: 14px;
  color: var(--color-main);
  width: 100%;
  line-height: 1;
  padding: 12px 15px;
  text-align: center;
}
.van-share-sheet>>>.van-share-sheet__option{
  width: 25%;
  flex: none;
}
.van-share-sheet>>>.van-share-sheet__name{
  padding: 0 8px;
  text-align: center;
}
.van-share-sheet>>>.van-action-sheet__item--disabled{
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
  opacity: .5;
}
</style>